module.exports = __webpack_public_path__ + "img/t4-headshot.8d432068.png";